export const Google_Api_Key = "AIzaSyCg_FibtkIF4BcoPTOXiCokN85kid-d9SM";

export const YOUTUBE_URL =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=US&key= AIzaSyCg_FibtkIF4BcoPTOXiCokN85kid-d9SM";

export const YOUTUBE_SEARCH_API =
  "http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=";

// export const VIDEO_CONTENT =
//   "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&id=Ks-_Mh1QhMc%2Cc0KYU2j0TM4%2CeIho2S0ZahI&key=" +
//   Google_Api_Key;

export const CHANNEL_ICON =
  "https://youtube.googleapis.com/youtube/v3/channels?part=snippet%2CcontentDetails%2Cstatistics&forUsername=GoogleDevelopers&key=" +
  Google_Api_Key;

export const VIDEO_CONTENT =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&key=AIzaSyCg_FibtkIF4BcoPTOXiCokN85kid-d9SM&id=";

export const Search_API =
  "https://youtube.googleapis.com/youtube/v3/search?part=snippet&maxResults=10&q=`${searchQuery}`&key= AIzaSyCg_FibtkIF4BcoPTOXiCokN85kid-d9SM";

export const Cmnt_API =
  "https://youtube.googleapis.com/youtube/v3/commentThreads?part=snippet%2Creplies&maxResults=200&videoId=_VB39Jo8mAQ&key=AIzaSyCg_FibtkIF4BcoPTOXiCokN85kid-d9SM";
